import { InjectedConnector } from "@web3-react/injected-connector";
import { toast } from "react-toastify";
import Web3 from "web3";
import Notify from "../components/Toast/Notify";
import { supportedChains, URL_INFURA_BSCMAINNET } from "../contract/constant";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { URL_INFURA_MAINNET, URL_INFURA_RINKEBY,URL_INFURA_BSCTESTNET } from "../contract/constant";
import WalletConnectProvider from "@walletconnect/web3-provider";

export const walletconnect = new WalletConnectConnector({
  supportedChainIds:supportedChains,
  rpc: {
    4: URL_INFURA_RINKEBY,
    97: URL_INFURA_BSCTESTNET,
    1:URL_INFURA_MAINNET,
    56:URL_INFURA_BSCMAINNET
  },
  qrcode: true,
});


export const injected = new InjectedConnector({
  // supportedChainIds: [1, 4],
  supportedChainIds: supportedChains,
});

export const switchNetwork = async (id) => {
  let networkData;
  if(localStorage.getItem("previousWallet") == "metaMask"){
  switch (id) {
    //ethmainnet
    case 1:
      networkData = [
        {
          chainId: "0x1",
        },
      ];
      break;

    //rinkebytestnet
    case 4:
      networkData = [
        {
          chainId: "0x4",
        },
      ];
      break;

    //bsctestnet
    case 97:
      networkData = [
        {
          chainId: "0x61",
          chainName: "BSCTESTNET",
          rpcUrls: ["https://data-seed-prebsc-1-s1.binance.org:8545"],
          nativeCurrency: {
            name: "BINANCE COIN",
            symbol: "BNB",
            decimals: 18,
          },
          blockExplorerUrls: ["https://testnet.bscscan.com/"],
        },
      ];
      break;

    //bscmainet
    case 56:
      networkData = [
        {
          chainId: "0x38",
          chainName: "BSCMAINET",
          rpcUrls: ["https://bsc-dataseed1.binance.org"],
          nativeCurrency: {
            name: "BINANCE COIN",
            symbol: "BNB",
            decimals: 18,
          },
          blockExplorerUrls: ["https://bscscan.com/"],
        },
      ];
      break;
    default:
      break;
  }
  let web3 = null;

    web3 = await new Web3(Web3.givenProvider);
  
  try {
    await web3.currentProvider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: networkData[0].chainId }],
    });
      toast(
        <Notify
          text={
            `Chain Switched Successfully to ${networkData[0].chainId==supportedChains[0]?"Ethereum Mainnet":"Bianance Smart Chain"}.`
          }
          severity="success"
        />
        ,
        {
          position: "bottom-right",
          toastId:"connectSuccessfull"
        }
      );
    
  } catch (error) {
    if (error.code === 4902) {
      try {
        await web3.currentProvider.request({
          method: "wallet_addEthereumChain",
          params: networkData,
        });
      } catch (error) {
        toast(
          <Notify
            text={
              `Switching to ${networkData[0].chainId==supportedChains[0]?"Ethereum Mainnet":"Bianance Smart Chain"} Unsuccessful.`
            }
            severity="error"
          />,
          {
            position: "bottom-right",
            toastId:"networkConnectionError"
          }
        );
        // alert(error.message);
      }
    }
    else if(error.code === 4001){
      toast(
        <Notify
          text={
            `Switching to ${networkData[0].chainId==supportedChains[0]?"Ethereum Mainnet":"Bianance Smart Chain"} Unsuccessful.`
          }
          severity="error"
        />,
        {
          position: "bottom-right",
          toastId:"networkConnectionError"
        }
      );
    }
    else if(error.code === -32002){
      toast(
        <Notify
          text={
            `Please respond to Metamask pop up to switch network`
          }
          severity="error"
        />,
        {
          position: "bottom-right",
          toastId:"networkCodeConnectionError"
        }
      );
    }
    else{
      // console.log("hello switch error: ", error)
      toast(
        <Notify
          text={
            `Connect the wallet first to switch the network`
          }
          severity="error"
        />,
        {
          position: "bottom-right",
          toastId:"networkCodeConnectionError"
        }
      );
    }
  }}
  else{
    toast(
      <Notify
        text={
          `Please Switch the network from metamask extension for wallet connect`
        }
        severity="error"
      />,
      {
        position: "bottom-right",
        toastId:"networkCodeConnectionError"
      }
    );
  }
};
